import React, { useState, useEffect } from 'react';
import { ConfirmDialog } from '../../../confirm-dialog/confirm-dialog';

export interface IConfirmCompleteAppointmentsDialogComponentProps {
  isOpen: boolean;
  onConfirmClick: () => void;
  onCancelClick?: () => void;
  selectedCount: number;
}

export function ConfirmCompleteAppointmentsDialogComponent(props: IConfirmCompleteAppointmentsDialogComponentProps) {
  const { isOpen, onConfirmClick, onCancelClick, selectedCount } = props;

  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsConfirmed(false);
    }
  }, [isOpen]);

  function handleConfirmClick() {
    setIsConfirmed(true);
    onConfirmClick && onConfirmClick();
  }

  return (
    <ConfirmDialog
      title="Ønsker du at afslutte aftalerne?"
      type="question"
      open={isOpen}
      onConfirmClick={handleConfirmClick}
      onCancelClick={onCancelClick}
      confirmButtonText="Ja"
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isConfirmed}
    >
      <div>Vil du markere {selectedCount > 1 ? `de ${selectedCount} valgte poster` : 'den valgte post'} som afsluttet?</div>
      <div>
        Bemærk, at alle følgende typer poster vil blive ignoreret:
        <ul>
          <li>Poster der ikke længere er markeret som planlagt.</li>
        </ul>
      </div>
    </ConfirmDialog>
  );
}
